import { useContext, useEffect } from "react"
import { Field } from "formik"
import { FormContext } from "../../context/formContext"
import { InputText as Input } from "primereact/inputtext"
import fieldVisibility from "../../helpers/fieldVisibility"
import { TRIM_TYPES, trimTextValue } from "./helpers/trimTextValue"
import styles from "../../styles/Form.module.css"

export default function TypeUrl({ field, block, index }) {
  const form = useContext(FormContext)
  let isDisabled = form ? form.blocksSaved[block] : false
  isDisabled = field.read_only ? true : isDisabled

  const checkIfRequired = () => {
    try {
      return JSON.parse(field.field_validation.required[0])
    } catch (error) {
      return false
    }
  }

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const isRequired = checkIfRequired()

  return (
    <div
      className={styles.field}
      style={{
        order: index,
        display: fieldVisibility(field.field_visibility),
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && <span className={styles.asterisk}> *</span>}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <div className={styles.value}>
        <Field name={field.field_name}>
          {({ field: formikField, meta, form: formik }) => (
            <>
              <Input
                name={formikField.name}
                value={formikField.value}
                onChange={formikField.onChange}
                disabled={isDisabled}
                onBlur={(e) => {
                  formik.setFieldValue(
                    formikField.name,
                    trimTextValue(e.target.value, TRIM_TYPES.BOTH),
                    true,
                  )
                  formikField.onBlur(e)
                }}
              />
              {meta.touched && meta.error && (
                <div className={styles.errFieldMsg}>{meta.error}</div>
              )}
            </>
          )}
        </Field>
      </div>
    </div>
  )
}
